import React, { useState, useEffect } from "react";
import "../Assets/Css/Login.css";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../Component/Loader";
import loginImg from "../Assets/Images/Dashboard/loginLeftBg.webp";
import hideIcon from "../Assets/Login/hide.png";
import showIcon from "../Assets/Login/show.png";
import { LOGIN_API } from "../Component/AllApi";
const Login = () => {
  const [values, setValues] = useState("");
  const [inputError, setInputError] = useState({});
  const [visible, setVisible] = React.useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  let navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user_role");
    // Replace current URL in history with the login page URL
    window.history.replaceState(null, "", "/");
  }, []);

  useEffect(() => {
    // Prevent going back to the previous page after logging out
    const clearHistory = () => {
      window.history.pushState(null, window.location.pathname);
      window.onpopstate = () => {
        navigate("/");
      };
    };
    clearHistory();
    return () => {
      window.onpopstate = null;
    };
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setInputError(validateForm(values));
    setLoading(true);

    try {
      const response = await fetch(LOGIN_API, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: values.email_or_mob,
          password: values.password,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const json = await response.json();
      // console.log("json", json);

      if (json.status === 200) {
        localStorage.setItem("authToken", json.token);
        // Saving the role for
        localStorage.setItem("user_role", json.user_role);
        setLoading(false);
        navigate("/select-section");
      } else {
        setVisible(true);
        console.error("Login failed:", json.message);
      }
    } catch (error) {
      console.error("Failed to fetch:", error);
      setVisible(true);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues((values) => ({
      ...values,
      [name]: value,
    }));
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const validateForm = (values) => {
    const error = {};
    const mobileRegx = /^[6789][0123456789]{9}$/;
    const emailRegx = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9]+[.-][a-zA-Z][a-z.A-Z]+$/;
    // const passwordRegx =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;
    if (!values.email_or_mob) {
      error.email_or_mob = "Please enter email id/mobile no.";
    } else if (
      emailRegx.test(values.email_or_mob) === false &&
      mobileRegx.test(values.email_or_mob) === false
    ) {
      error.email_or_mob = "Please enter valid email id/mobile no.";
    }

    if (!values.password) {
      error.password = "Please enter password.";
    }
    // else if (values.password.length < 8) {
    //   error.password = "Please enter valid password.";
    // }

    return error;
  };
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <section className="loginPage">
            <div className="container-fluid">
              <div
                className="container"
                style={{ boxShadow: "0px 4px 34px 0px #B6C1C757" }}
              >
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-6 col-12">
                    <img src={loginImg} alt="loginImg" className="img-fluid" />
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-6 col-12 p-5 formDiv">
                    {visible && (
                      <div className="alert alert-danger mt-4 " role="alert">
                        Please enter valid credential
                      </div>
                    )}
                    {/* <p className="himachalTitle">Himachal</p> */}
                    <p className="loginTitle">Log In</p>
                    <form action="" onSubmit={handleSubmit}>
                      <label htmlFor="">Email Id/ Mobile no.</label>
                      <input
                        type="text"
                        className="form-control"
                        value={values.email_or_mob}
                        onChange={handleInputChange}
                        name="email_or_mob"
                      />
                      <p className="error-msg mt-2">
                        {inputError.email_or_mob}
                      </p>
                      <label htmlFor="">Password</label>
                      <div className="password-input-wrapper">
                        <input
                          type={passwordVisible ? "text" : "password"}
                          className="form-control mb-2"
                          value={values.password}
                          onChange={handleInputChange}
                          name="password"
                          id="password"
                        />
                        <img
                          src={passwordVisible ? showIcon : hideIcon}
                          alt="eye-icon"
                          className="login_show_pass_icon"
                          onClick={togglePasswordVisibility}
                        />
                      </div>

                      <span className="error-msg">{inputError.password}</span>
                      <input
                        type="submit"
                        value="Log In"
                        className="w-100 btn loginBtn"
                      />
                    </form>
                    <p className="terms">
                      By logging in, you agree to the{" "}
                      <Link
                        to="https://himachal.phntechnology.com/terms-conditions"
                        target="_blank"
                      >
                        <u style={{ color: "black" }}>Terms of Service</u>
                      </Link>{" "}
                      and{" "}
                      <Link
                        to="https://himachal.phntechnology.com/privacy-policy"
                        target="_blank"
                      >
                        <u style={{ color: "black" }}>Privacy Policy</u>
                      </Link>
                      , including <u>cookie use</u>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default Login;
